module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-markdown-5fddd24bc278682c985e955612200cdc.svg";